import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { ProductSetupsService } from '../../../product-setups/core/services/ProductSetupsService';
import { IMySetupStep } from '../../../product-setups/core/interfaces/IProductSetupWidgets';
import { formatSetupWaiting } from '../../core/utils/formatSetupWaiting';

@Component({
  selector: 'app-my-next-setup-steps-chart',
  templateUrl: './my-next-setup-steps-chart.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MyNextSetupStepsChartComponent implements OnInit {

  public items: IMySetupStep[] = [];
  public isLoading = false;
  public failed = false;

  private readonly _productSetupsService = inject(ProductSetupsService);
  private readonly _cdr = inject(ChangeDetectorRef);

  public ngOnInit(): void {
    this.isLoading = true;
    this.failed = false;

    this._productSetupsService.mine()
      .pipe(
        finalize(() => {
          this.isLoading = false;
          this._cdr.markForCheck();
        })
      )
      .subscribe({
        next: res => this.items = res,
        error: () => {
          this.items = [];
          this.failed = true;
        }
      });
  }

  public waiting(waitingSince: string): string {
    return formatSetupWaiting(waitingSince);
  }
}
